module.exports = __webpack_public_path__ + "img/idcardback.773b7609.png";